import { render, staticRenderFns } from "./FilterSwitch.vue?vue&type=template&id=03f56212"
import script from "./FilterSwitch.vue?vue&type=script&lang=js"
export * from "./FilterSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports